/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {MS_DHONI,
    AB_DE_VILLIERS,
    JOE_ROOT,
    RICKY_PONTING,
    DAVID_WARNER,
    SRIKANTH
} from '../../assets/images';
export const TEST_DATA = [
    {
        idx: "15",
        title: "K. Srikkanth Square Drive",
        subtitle: "In his time the Indiana Jones of Indian cricket, Srikkanth's batting style was entertaining, innovative and explosive.",
        serialNo: 'Rare #/1250',
        img: SRIKANTH,
        tag: 'PLATINUM',
        category: 'platinum',
        price: [
            {
                type: 'fiat',
                currency: 'USD',
                locale: 'en-US',
                amount: 2500.00
            },
            {
                type: 'crypto',
                currency: 'ETH',
                amount: 0.6900
            }
        ]
    },
    {
        idx: "16",
        title: "K. Srikkanth Cover Drive",
        subtitle: "In his time the Indiana Jones of Indian cricket, Srikkanth's batting style was entertaining, innovative and explosive.",
        serialNo: 'Rare #/1251',
        img: "https://i.ibb.co/JmLxbXt/ssrikanth-2.png",
        tag: 'DIAMOND',
        category: 'diamond',
        price: [
            {
                type: 'fiat',
                currency: 'USD',
                locale: 'en-US',
                amount: 2000.00
            },
            {
                type: 'crypto',
                currency: 'ETH',
                amount: 0.55
            }
        ],
    },
    {
        idx: "3",
        title: "MS Dhoni",
        subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
        serialNo: 'Rare #/1200',
        img: MS_DHONI,
        tag: 'DIAMOND',
        category: 'diamond',
        price: [
            {
                type: 'fiat',
                currency: 'USD',
                locale: 'en-US',
                amount: 1500.00
            },
            {
                type: 'crypto',
                currency: 'ETH',
                amount: 0.5123
            }
        ]
    },
    {
        idx: "3",
        title: "AB De Villiers",
        subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
        serialNo: 'Rare #/1201',
        img: AB_DE_VILLIERS,
        tag: 'GOLD',
        category: 'gold',
        price: [
            {
                type: 'fiat',
                currency: 'USD',
                locale: 'en-US',
                amount: 432.00
            },
            {
                type: 'crypto',
                currency: 'ETH',
                amount: 0.01
            }
        ]
    },
   
    {
        idx: "3",
        title: "Joe Root",
        subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
        serialNo: 'Rare #/1202',
        img: JOE_ROOT,
        tag: 'PLATINUM',
        category: 'platinum',
        price: [
            {
                type: 'fiat',
                currency: 'USD',
                locale: 'en-US',
                amount: 859.00
            },
            {
                type: 'crypto',
                currency: 'ETH',
                amount: 0.01
            }
        ]
    },
    {
        idx: "3",
        title: "Ricky Ponting",
        subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
        serialNo: 'Rare #/1203',
        img: RICKY_PONTING,
        price: [
            {
                type: 'fiat',
                currency: 'USD',
                locale: 'en-US',
                amount: 52.00
            },
            {
                type: 'crypto',
                currency: 'ETH',
                amount: 0.01
            }
        ]
    },
     {
        idx: "3",
        title: "David Warner",
        subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
        serialNo: 'Rare #/1204',
        img: DAVID_WARNER,
        price: [
            {
                type: 'fiat',
                currency: 'USD',
                locale: 'en-US',
                amount: 52.00
            },
            {
                type: 'crypto',
                currency: 'ETH',
                amount: 0.01
            }
        ]
    },
]

export const FilterData = [
    {
        type: "button",
        title: "Type",
        key: "ex4",
        categories: [
          { label: "Crypto", value: "Crypto" },
          { label: "NFT", value: "NFT" }
        ]
      },
      {
        type: "button",
        title: "Country",
        key: "id-4",
        categories: [
          { label: "India", value: "Ind" },
          { label: "U.S.A.", value: "usa" },
          { label: "Canada", value: "canada" },
          { label: "Barbados", value: "barbados" },
          { label: "Dominica", value: "dominica" },
          { label: "Jamaica", value: "jamaica" },
        ]
      },
    {
      type: "checkbox",
      title: "Categories",
      key: "id-5",
      categories: [
        { label: "Badminton", value: "Badminton" },
        { label: "Cricket", value: "Cricket" },
        { label: "Football", value: "Football" },
        { label: "Hockey", value: "Hockey" },
        { label: "Volleyball", value: "Volleyball" },
        { label: "Basketball", value: "Basketball" },
        { label: "Tennis", value: "Tennis" },
        { label: "Table Tennis", value: "Table Tennis" },
        { label: "Baseball", value: "Baseball" },
        { label: "Golf", value: "Golf" }
      ]
    },
    {
      type: "checkbox",
      title: "Time period",
      key: "id-6",
      categories: [
        { label: "2001-2004", value: "2001-2004" },
        { label: "2005-2008", value: "2005-2008" },
        { label: "2009-2012", value: "2009-2012" },
        { label: "2013-2016", value: "2013-2016" },
        { label: "2017-2020", value: "2017-2020", disabled: true },
        { label: "2021", value: "2021" },
      ]
    },
    {
      type: "range",
      title: "Price",
      key: "id-9",
      min: 0,
      max: 200,
      default: "ETH",
      subCategoriesTitle: "Currency",
      categories: [
        { label: "USD", value: "USD" },
        { label: "Ethereum", value: "ETH" },
        { label: "Indian Rupee", value: "INR" }
      ]
    }
  ];